import { AuthService } from "@js/services/AuthService";
import { OrganisationService } from "@js/services/OrganisationService";
import { AuthClient, Organisation, OrganisationClient, StaticDataClient } from "@src/apis/ModularClient";

export class NewSearchSelectionsController {
  selectedRole: number;

  RoleEnum = {
    All: 0,
    DevelopmentFinance: 1,
    BridgingFinance: 2,
    Clients: 3,
  };

  selectedNavMenu: number;
  brokerageOrg: Organisation;
  hasBridging: boolean = false;
  hasCommercial: boolean = false;
  dataLoading: boolean = false;
  selectedProduct: string = null;
  userDetails: string = null;

  isCommercialOwnerOccupiedActive: boolean = false;

  static $inject = [
    "$rootScope",
    "$routeParams",
    "$location",
    "$cookies",
    "StaticDataClient",
    "OrganisationService",
    "OrganisationClient",
  ];

  constructor(
    private $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private $cookies: ng.cookies.ICookiesService,
    private staticDataClient: StaticDataClient,
    private organisationService: OrganisationService,
    private organisationClient: OrganisationClient,
  ) {
    this.staticDataClient.isCommercialOwnerOccupiedActive().then((response) => {
      this.isCommercialOwnerOccupiedActive = response;
    });

    this.getUser()
      .then(() => {
        (this.$rootScope as any).isInvitedAndHasReadonlyAccess = false;

        if (this.$routeParams["Type"] == "bridging") {
          this.selectedRole = this.RoleEnum.BridgingFinance;
          this.selectedNavMenu = this.RoleEnum.BridgingFinance;
        } else {
          this.selectedRole = this.RoleEnum.All;
          this.selectedNavMenu = this.RoleEnum.All;
        }

        if (window.self == window.top && $cookies.get("access_token")) {
          this.organisationClient.getOrganisationProductAccess().then((response) => {
            this.hasBridging = response.hasBridging;
            this.hasCommercial = response.hasCommercial;
            this.checkProductSelected();
          });
        } else {
          var orgCode = location.pathname.replace("/", "");
          if (orgCode && orgCode.length > 0) {
            this.organisationClient.findOrganisationByOrgCode(location.pathname.replace("/", "")).then((org) => {
              this.hasBridging = org?.hasBridging;
              this.hasCommercial = org?.hasCommercialMortgage;
              this.checkProductSelected();
            });
          } else {
            //This is for borrower belong to BF org
            this.hasBridging = true;
            this.hasCommercial = true;
          }
        }
      })
      .catch((error) => {
        console.error("Failed to get initialize data: ", error);
      });
  }

  async getUser(): Promise<void> {
    if (window.self == window.top) {
      this.userDetails = sessionStorage.getItem("userDetails");
    } else {
      this.userDetails = await this.organisationService.getData("userDetails");
    }
  }

  goToNewDevFinanceSearch(productSelected: boolean = false) {
    if (productSelected || this.userDetails) {
      if (this.hasBridging) {
        //localStorage.removeItem('selectedProduct');
        this.$location.path("/criteria");
      }
    } else {
      this.selectedProduct = "devFinance";
      this.$location.path("/borrowerinitialregistration");
    }
  }

  goToNewBridgingSearch(productSelected: boolean = false) {
    if (productSelected || this.userDetails) {
      if (this.hasBridging) {
        //localStorage.removeItem('selectedProduct');
        this.$location.path("/bridgingcriteria");
      }
    } else {
      sessionStorage.setItem("selectedProduct", "bridging");
      this.$location.path("/bridgingcriteria");
    }
  }

  goToNewCommercialSearch() {
    if (this.userDetails) {
      if (this.hasCommercial) {
        this.$location.path("/commercialcriteria");
      }
    }
  }

  goToNewPurchaseOrRefinanceSearch(productSelected: boolean = false) {
    if (productSelected || sessionStorage.getItem("userDetails")) {
      if (this.hasBridging) {
        sessionStorage.removeItem("selectedProduct");
        this.$location.path("/purchaserefinancecriteria");
      }
    } else {
      this.selectedProduct = "purchaseOrRefinance";
      this.$location.path("/bridgingcriteria");
    }
  }

  checkProductSelected() {
    switch (this.selectedProduct) {
      case null:
        break;
      case "devFinance":
        this.goToNewDevFinanceSearch(true);
        break;
      case "bridging":
        this.goToNewBridgingSearch(true);
        break;
      case "purchaseOrRefinance":
        this.goToNewPurchaseOrRefinanceSearch(true);
        break;
      default:
        return;
    }
  }
}
